/**
 * Admin 主应用组件
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

import Layout from '@/components/layout/Layout';
import Dashboard from '@/pages/Dashboard';
import QuizList from '@/pages/QuizList';
import QuizCreate from '@/pages/QuizCreate';
import QuizEdit from '@/pages/QuizEdit';
import CodeManagement from '@/pages/CodeManagement';
import UserManagement from '@/pages/UserManagement';
import AttemptManagement from '@/pages/AttemptManagement';
import Settings from '@/pages/Settings';

// 创建 Query Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5分钟
      cacheTime: 10 * 60 * 1000, // 10分钟
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Layout>
            <Routes>
              {/* 仪表板 */}
              <Route path="/" element={<Dashboard />} />
              
              {/* 题集管理 */}
              <Route path="/quizzes" element={<QuizList />} />
              <Route path="/quizzes/create" element={<QuizCreate />} />
              <Route path="/quizzes/:id/edit" element={<QuizEdit />} />
              
              {/* 兑换码管理 */}
              <Route path="/codes" element={<CodeManagement />} />
              <Route path="/codes/:quizId" element={<CodeManagement />} />
              
              {/* 用户管理 */}
              <Route path="/users" element={<UserManagement />} />
              
              {/* 答题记录 */}
              <Route path="/attempts" element={<AttemptManagement />} />
              <Route path="/attempts/:quizId" element={<AttemptManagement />} />
              
              {/* 系统设置 */}
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </Layout>
        </div>
        
        {/* Toast 通知 */}
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              style: {
                background: '#22c55e',
              },
            },
            error: {
              style: {
                background: '#ef4444',
              },
            },
          }}
        />
      </Router>
    </QueryClientProvider>
  );
}

export default App;